import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { GlobalContext } from "../../context/GlobalContext";
import { RoutesNames } from "../utils/routes";
import IconMenu from "../Icons/IconMenu";
import ModalLogOut from "../../Modals/ModalLogOut";
import ModalMenu from "../../Modals/ModalMenu";

import {
  ButtonLogOut,
  ContainerIcon,
  ContainerOption,
  ContainerOptions,
  ContainerWelcome,
  Header,
  TextOthers,
  TextWelcome,
  Title,
} from "./styles";

const HeaderMain = () => {
  const { rol, user } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [modalMenu, setModalMenu] = useState(false);
  const [modalLogout, setModalLogout] = useState(false);
  return (
    <Header>
      <Title onClick={() => navigate(RoutesNames.main)}>Admon Portal</Title>
      <ContainerWelcome>
        <TextWelcome>Bienvenido, {user}</TextWelcome>
        <ContainerIcon onClick={() => setModalMenu(!modalMenu)}>
          <IconMenu color="#fff" />
        </ContainerIcon>
      </ContainerWelcome>
      <ModalMenu modalOpen={modalMenu}>
        <>
          {rol === "ADMIN" ? (
            <ContainerOptions>
              <ContainerOption onClick={() => navigate(RoutesNames.interestThemes)}>
                <TextOthers>Temas de interés</TextOthers>
              </ContainerOption>
              <ContainerOption>
                <ButtonLogOut
                  onClick={() => {
                    setModalMenu(false);
                    setModalLogout(true);
                  }}
                >
                  Cerrar sesión
                </ButtonLogOut>
              </ContainerOption>
            </ContainerOptions>
          ) : (
            <ContainerOptions>
              <ContainerOption>
                <ButtonLogOut
                  onClick={() => {
                    setModalMenu(false);
                    setModalLogout(true);
                  }}
                >
                  Cerrar sesión
                </ButtonLogOut>
              </ContainerOption>
            </ContainerOptions>
          )}
        </>
      </ModalMenu>
      <ModalLogOut modalVisible={modalLogout} setModalVisible={setModalLogout} />
    </Header>
  );
};

export default HeaderMain;
